import { deleteBilling } from "@/server/api-services";

export const permissions = {
    system: {
        admin: "system.admin",
        user: "system.user",
        customer: "system.customer",
    },
    products: {
        view: "products.view",
        create: "products.create",
        edit: "products.edit",
        delete: "products.delete",
    },
    users: {
        view: "users.view",
        create: "users.create",
        edit: "users.edit",
        delete: "users.delete",
        getUserById: "users.getUserById",
        getUserByEmail: "users.getUserByEmail",
        getUsersByRole: "users.getUsersByRole",
        assignRole: "users.assignRole",
        removeRole: "users.removeRole",
    },
    roles: {
        view: "roles.view",
        create: "roles.create",
        edit: "roles.edit",
        delete: "roles.delete",
        getRoleById: "roles.getRoleById",
        assignPermissions: "roles.assignPermissions",
    },
    orders: {
        view: "orders.view",
        create: "orders.create",
        edit: "orders.edit",
        delete: "orders.delete",
        startProcessing: "orders.startProcessing",
        purchase: "orders.purchase",
        ship: "orders.ship",
        inTransit: "orders.inTransit",
        deliver: "orders.deliver",
        cancel: "orders.cancel",
        complete: "orders.complete",
        updateStatus: "orders.updateStatus",
        addPurchaseOrder: "orders.addPurchaseOrder",
        searchByTrackingNumber: "orders.searchByTrackingNumber",
        recordShipment: "orders.recordShipment",
        updateShipment: "orders.updateShipment",
        getTracks: "orders.getTracks",
        addTrack: "orders.addTrack"
    },
    transactions: {
        getTransactionByOrder: "transactions.getTransactionByOrder",
        addTransaction: "transactions.addTransaction",
        deleteTransaction: "transactions.deleteTransaction"
    },
    customers: {
        view: "customers.view",
        create: "customers.create",
        edit: "customers.edit",
        delete: "customers.delete",
    },
    clients: {
        view: "clients.view",
        create: "clients.create",
        edit: "clients.edit",
        delete: "clients.delete",
    },
    categories: {
        view: "categories.view",
        create: "categories.create",
        edit: "categories.edit",
        delete: "categories.delete",
    },
    reports: {
        view: "reports.view",
        generate: "reports.generate",
    },
};

// generate array of permissions use this template { value: "permission", label: "Permission" } only show inner object keys
export const permissionsArray = Object.keys(permissions).flatMap((key) => {
    return Object.keys(permissions[key]).map((innerKey) => {
        return {
            value: permissions[key][innerKey],
            label: `${key}.${innerKey}`,
        };
    });
});
